import { db } from '../FirebaseLibrary';
import { cachedFirestoreFetch } from './FirestoreFetchCache';

export const createProductsReference = () => {
    return db.collection('products');
};

export const createProductReference = (productId: string) => {
    return createProductsReference().doc(productId);
};

export const fetchProductFirestoreAPI = (productId: string) => {
    return createProductReference(productId).get();
};

export const fetchProductsFirestoreAPI = (teamId: string) => {
    return cachedFirestoreFetch(`products|${teamId}`, () => {
        return createProductsReference()
            .where('teamId', '==', teamId)
            .where('published', '==', true)
            .where('archived', '==', false)
            .where('deleted', '==', false)
            .orderBy('order', 'desc')
            .orderBy('timeCreated', 'desc')
            .get();
    });
};

export const fetchLinkedProductsFirestoreAPI = (teamId: string) => {
    return cachedFirestoreFetch(`linked-products|${teamId}`, () => {
        return createProductsReference()
            .where('linkedStoreIds', 'array-contains', teamId)
            .where('published', '==', true)
            .where('archived', '==', false)
            .where('deleted', '==', false)
            .orderBy('order', 'desc')
            .orderBy('timeCreated', 'desc')
            .get();
    });
};

export const hasFeaturedProductsFirestoreAPI = (teamId: string) => {
    return createProductsReference().where('teamId', '==', teamId).where('featureProduct', '==', true).where('published', '==', true)
        .limit(1)
        .get();
};
